import clsx from 'clsx';
import { Heading } from 'copilot-design-system';

export const ProductTitleHeader = ({
  title,
  isPreview,
}: {
  title: string;
  isPreview: boolean;
}) => {
  return (
    <div className="flex flex-col gap-5 px-6 pb-4">
      <Heading
        className={clsx('font-medium text-black-heading ', {
          'text-lg': isPreview,
          'text-xl md:text-2xl ': !isPreview,
        })}
      >
        {title}
      </Heading>
    </div>
  );
};
